/* leverege-molten no-export */
import { Config } from '@leverege/plugin';
import I18N from '@leverege/i18n';
import Util from "./Util.js";
const {
  t,
  tf,
  tIcon
} = I18N.ns('molten.screens.account.BetaFeedback');
export default {
  id: 'molten.BetaFeedback',
  matches: {
    use: 'userBar',
    client: 'Main'
  },
  name: tf('name'),
  layout: Config.get('BetaSwitch', 'feedbackLayout', {
    group: ['beta'],
    groupIcons: [() => {
      return Util.isBetaOn() ? tIcon('iconBetaOn', 'https://molten-ui-assets.storage.googleapis.com/icon-beta-on.png') : tIcon('iconBetaOff', 'https://molten-ui-assets.storage.googleapis.com/icon-beta-off.png');
    }],
    groupNames: ['Beta Mode'],
    sort: '_b.a',
    sectionName: tf('sectionName')
  }),
  sort: '__a',
  handles: () => {
    return Config.get('BetaSwitch', 'enabled', false);
  },
  appearance: () => {
    return {
      name: t('name'),
      icon: tIcon('icon', 'https://molten-ui-assets.storage.googleapis.com/icon-beta-feedback.png')
    };
  },
  perform: (...args) => {
    const perfFunc = Config.get('BetaSwitch', 'feedbackPerform', cxt => {
      if (Config.get('BetaSwitch', 'feedbackLink')) {
        window.open(Config.get('BetaSwitch', 'feedbackLink'), '_blank');
      } else {
        console.error(new Error('No link provided for BetaSwitch.feedbackLink in Config'));
      }
    });
    return perfFunc(...args);
  }
};